// extracted by mini-css-extract-plugin
module.exports = {"supplyItem":"SupplyItem_supplyItem__2ia-8"};